<template>
  <div>
    <div class="title mt-5">
      <h3 class="d-flex justify-content-center header">
        {{$t('headers.hearing_test')}}
      </h3>
    </div>
    <!-- Hearing Test Part 2 -->
    <div class="container mt-3">

      <div v-if="!hasStarted" class="mt-3">
        
        <div class="d-flex justify-content-center">
          <span class="header header-2">
            {{$t('numbers_test.adjust_volume')}}
          </span>
        </div>

        <div class="d-flex justify-content-center mt-md-5">
          <img src="public/sound.svg" alt="" class="sound-icon">
        </div>
        
        <div class="d-flex justify-content-center mt-5">
          <button type="button" class="button primary" @click="startStage">{{$t('actions.start')}}</button>
        </div>

        <br>
      </div>

      <div v-else class="pt-5 d-flex flex-column align-items-center">

        <fade-transition :duration="250" mode="out-in">

          <div key="countdown" v-if="countdown.value > 0" class="d-flex justify-content-center mb-5">
            <span class="header header-bolder" v-text="countdown.value"></span>
          </div>

          <div key="hearing-test" v-else>
            <div class="d-flex justify-content-center mb-5">
              <span class="header header-2">{{$t('second_stage.instructions_message')}}</span>
            </div>

            <div class="hearing-test-main d-flex w-100">
              <div class="d-flex justify-content-end sound-wrapper">
                <img v-if="showLeftAnimation" class="sound-waves mr-2 mb-5" :src="leftImage">
              </div>
              <div class="d-flex">
                <img @click="saveUserInput" class="hearing-test-button" src="public/ear.svg" alt="">
              </div>
              <div class="d-flex justify-content-start">
                <img v-if="showRightAnimation" class="sound-waves mr-2 mb-5" :src="rightImage">
              </div>
            </div>
          </div>

        </fade-transition>
      </div>
    </div>
  </div>
</template>
<script>
import FadeTransition from '@/vue-components/Utils/FadeTransition.vue'
export default {
  components: {
    FadeTransition
  },
  props: {
    handler: {
      type: Object,
      required: true
    },
    ht: {
      type: Object,
      required: false
    }
  },
  data () {
    return {
      hearingTest: null,
      showRightAnimation: false,
      showLeftAnimation: false,
      hasStarted: false,
      activeImageIndex: 1,
      activeImageEar: null,
      interval: null,
      countdown: {
        interval: null,
        value: 3
      }
    }
  },
  created () {
    // Setup listeners for hearing test
    this.handler.hearingTestManager.eventEmitter.on('hearingTestStarted', this.updateHearingTest)
    this.handler.hearingTestManager.eventEmitter.on('frequencyIncreased', this.updateHearingTest)
    this.handler.hearingTestManager.eventEmitter.on('channelUpdated', this.updateHearingTest)
    this.handler.hearingTestManager.eventEmitter.on('hearingTestFinished', (payload) => {
      this.$emit('update:ht', payload)
      this.$emit('continue')
    })
    this.handler.playTonalInstructions()
  },
  methods: {
    updateHearingTest: function (payload) {
      this.hearingTest = payload
    },
    initAnimation: function () {
      this.interval = setInterval(() => {
        if (this.activeImageIndex + 1 <= 3) {
          this.activeImageIndex ++
        } else {
          this.activeImageIndex = 1
        }
      }, 1000)
    },
    startStage: function () {
      console.log('startStage clicked')
      this.hasStarted = true
      this.handler.stopTonalInstructions()
      // Start playing hearing test
      this.countdown.interval = setInterval(() => {
        if (this.countdown.value - 1 >= 0) {
          this.countdown.value --
        }
      }, 1000)
    },
    saveUserInput: function () {
      this.handler.handleUserInput()
    }
  },
  computed: {
    rightImage: function () {
      return `public/right_${this.activeImageIndex}.svg`
    },
    leftImage: function () {
      return `public/left_${this.activeImageIndex}.svg`
    }
  },
  watch: {
    'countdown.value': {
      handler: function (value) {
        console.log(value)
        if (value === 0) {
          clearInterval(this.countdown.interval)
          this.handler.init()
          setTimeout(() => {
            this.initAnimation()
          }, 500)
        }
      }
    },
    hearingTest: {
      handler: function (value) {
        if (value.channel === 'single') {
          this.showLeftAnimation = true
          this.showRightAnimation = true
        } else if (value.channel === 'left') {
          this.showLeftAnimation = true
          this.showRightAnimation = false
        } else if (value.channel === 'right') {
          this.showLeftAnimation = false
          this.showRightAnimation = true
        }
      },
      deep: true
    }
  }
}
</script>

<style scoped>

.hearing-test-button {
  width: 150px;
  height: 150px;
  cursor: pointer;
}

.hearing-test-button:active {
  transform: translateY(4px);
}

.sound-wrapper {
  min-width: 43%;
}

.sound-waves {
  width: 125px;
  height: 150px;
}

@media only screen and (max-width: 768px) {
  
  .hearing-test-button {
    width: 115px;
    height: 115px;
    cursor: pointer;
  }

  .sound-wrapper {
    min-width: 33%;
  }

  .sound-waves {
    width: 90px;
    height: 110px;
  }
}

.sound-icon {
  height: 250px;
  max-height: 30vh;
}

</style>